import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

export function formatDateShort(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
    });
}

export function getStatusColor(estado) {
    const colors = {
        pendiente: 'status-pendiente',
        autorizado: 'status-autorizado',
        despachado: 'status-despachado',
        rechazado: 'status-rechazado'
    };
    return colors[estado] || 'status-pendiente';
}

export function getStatusLabel(estado) {
    const labels = {
        pendiente: 'Pendiente',
        autorizado: 'Autorizado',
        despachado: 'Despachado',
        rechazado: 'Rechazado'
    };
    return labels[estado] || estado;
}

export function getRolLabel(rol) {
    const labels = {
        admin: 'Administrador',
        solicitante: 'Solicitante',
        gerente: 'Gerente',
        seguridad: 'Seguridad'
    };
    return labels[rol] || rol;
}

export function validateRUT(rut) {
    if (!rut || rut.length < 3) return false;
    const cleanRut = rut.replace(/[.-]/g, '').toUpperCase();
    const body = cleanRut.slice(0, -1);
    const dv = cleanRut.slice(-1);
    
    let sum = 0;
    let multiplier = 2;
    
    for (let i = body.length - 1; i >= 0; i--) {
        sum += parseInt(body[i]) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }
    
    const expectedDv = 11 - (sum % 11);
    const calculatedDv = expectedDv === 11 ? '0' : expectedDv === 10 ? 'K' : String(expectedDv);
    
    return dv === calculatedDv;
}

export function formatRUT(rut) {
    if (!rut) return '';
    const cleanRut = rut.replace(/[.-]/g, '');
    const body = cleanRut.slice(0, -1);
    const dv = cleanRut.slice(-1);
    
    let formatted = '';
    for (let i = body.length - 1, j = 0; i >= 0; i--, j++) {
        if (j > 0 && j % 3 === 0) {
            formatted = '.' + formatted;
        }
        formatted = body[i] + formatted;
    }
    
    return `${formatted}-${dv}`;
}

export function formatPatente(patente) {
    if (!patente) return '';
    return patente.toUpperCase().replace(/[^A-Z0-9]/g, '');
}
